import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Subject, combineLatest } from "rxjs";
import { StoreService } from "./store.service";
import { map, switchMap, takeUntil } from "rxjs/operators";
import { Pais } from "../enums";
import { ArticulosService } from "./articulos.service";
import { CartService } from "./cart.service";
import { CartService as CartStoreService } from "../services/cart/cart.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  public language$ = new BehaviorSubject<string>("");
  private readonly onDestroy$ = new Subject<void>();
  private readonly KEY = "lang_overfly";

  constructor(
    private _store: StoreService,
    public _translate: TranslateService,
    private _articulos: ArticulosService,
    private _cart: CartStoreService,
    private cartService: CartService,
    private _router: Router
  ) {}

  public init() {
    const lang = localStorage.getItem(this.KEY);
    this.onChange();
    if (!lang) return;
    if (!(lang === "en" || lang === "es")) return;
    this.language$.next(lang);
    return lang;
  }

  private onChange() {
    this.language$.subscribe((value) => {
      if (value === "en" || value === "es") {
        localStorage.setItem(this.KEY, value);
        this._translate.use(value);
        this._store.lineas = value == 'es' ? this._store.lineasMX : this._store.lineasUSA;
      }
    });
  }


  changeLanguage(lang: string): void {
    this._translate.use(lang);
    this._cart.remove();
    this.cartService.clearCart();
    this.cartService.recalcularPrecio();
    this._router.navigate(['/']);
    combineLatest([
      this._translate.onLangChange,
      this._store.lineasObservable$
    ])
    .pipe(
      switchMap(([{ lang }, lineas]) => {
        return this._articulos
          .categorias(lang === "es" ? Pais.Mexico : Pais.EstadosUnidos)
          .pipe(map((categorias) => ({ lang, lineas, categorias })));
      }),
      takeUntil(this.onDestroy$)
    )
    .subscribe(({ lang, lineas, categorias }) => {
      // Aquí aplicas la lógica que necesitas al cambiar el idioma
      if (lang === "es") {
        this._store.lineas = this._store.lineasMX;

      } else {
        this._store.lineas = this._store.lineasUSA;
      }
    });
  }
}
